import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }  from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { AngularMaterialModule } from '../angular-material.module';

import { ManageInvoiceRebService } from './manage-invoice-reb.service';
import { ManageInvoiceRebComponent } from './manage-invoice-reb.component';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    ManageInvoiceRebService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    ManageInvoiceRebComponent
  ],
  exports: [
    ManageInvoiceRebComponent
  ]
})
export class ManageRebInvoiceModule { }
